import Cookie from 'js-cookie'
import Pusher from 'pusher-js'

import { getBaseURI } from 'client/links/httpLink'

const DB_USER_REGION_KEY = 'DB_USER_REGION'
class PusherService {
  constructor() {
    this.pusher = null
    this.accessToken = null
    this.apiBaseUrl = null
    this.pusherKey = import.meta.env.VITE_PUSHER_KEY
    this.pusherCluster = import.meta.env.VITE_PUSHER_CLUSTER
  }

  getInstance() {
    const accessToken = Cookie.get('access-token')
    const apiBaseUrl = getBaseURI(localStorage.getItem(DB_USER_REGION_KEY))

    if (
      this.pusher &&
      (this.accessToken !== accessToken || this.apiBaseUrl !== apiBaseUrl)
    ) {
      this.disconnect()
    }

    if (!this.pusher) {
      Pusher.logToConsole = import.meta.env.VITE_ENV === 'staging'

      this.pusher = new Pusher(this.pusherKey, {
        cluster: this.pusherCluster,
        authEndpoint: `${apiBaseUrl}/rest/v2/notifications/authorize_notifications`,
        auth: {
          headers: { 'X-Access-Token': accessToken }
        }
      })
      this.accessToken = accessToken
      this.apiBaseUrl = apiBaseUrl
    }
    return this.pusher
  }

  disconnect() {
    if (this.pusher) {
      this.pusher.disconnect()
      this.pusher = null
      this.accessToken = null
      this.apiBaseUrl = null
    }
  }
}

const pusherService = new PusherService()
export default pusherService
